export default __webpack_public_path__ + "static/logo-e0a777fc084bd12177d89aff268880dd.png";